<script setup lang="ts">
// Terms of Sale, as the app shows it (components/LegalPage.vue).
</script>

<template>
  <LegalPage doc="terms" />
</template>
